<template>
  <div>
    <loginheader flagg="1"></loginheader>
    <div class="mylogin">
      <div class="bgimg"></div>
      <loginfotter class="myfoot"></loginfotter>
    </div>
  </div>
</template>

<script>
import loginheader from "./loginheader.vue";
import loginfotter from "./loginfotter.vue";

export default {
  name: "App",
  props: ["flag"],
  props: ["flag1"],
  components: {
    loginheader,
    loginfotter
  }
};
</script>

<style>
.myfoot {
  position: absolute;
  bottom: 0;
}

.bgimg {
  background: url(../img/bgimg.png) no-repeat;
  width: 100%;
  height: 1100px;
  box-sizing: border-box;
  padding: 0 18%;
  display: flex;
  justify-content: flex-end;
}
.mylogin {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/mylogin.vue